const URLENCODE_LINE_BREAK = '%0a';

export const formatForWhatsApp = (text: string) => text.replace(/\n/g, URLENCODE_LINE_BREAK);
